module.exports = __webpack_public_path__ + "assets/images/coin-25-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-25-on.png
// module id = 1504
// module chunks = 1